import { Plugin } from '@nuxt/types'

/**
 * Client-side plugin to hide the app loading indicator.
 *
 * This plugin uses Vue Router's onReady() callback which fires when
 * the initial navigation is complete (after async components and
 * async hooks are resolved).
 *
 * The loading indicator is defined in app.html and shows immediately
 * when the HTML is delivered, providing instant visual feedback during
 * SSR hydration.
 */
const appLoaderPlugin: Plugin = ({ app }) => {
  // Only run on client-side
  if (process.server) return

  const hideLoader = (): void => {
    const loader = document.getElementById('app-loading')
    if (loader) {
      loader.remove()
    }
  }

  // Use Vue Router's onReady - fires when initial navigation is complete
  // This is the most reliable way to know when the app is ready to be shown
  if (app.router) {
    app.router.onReady(() => {
      hideLoader()
    })
  } else {
    // Fallback: if router is not available, hide immediately
    hideLoader()
  }
}

export default appLoaderPlugin
